import type { Ref } from 'vue';
import { watch } from 'vue';
import type { HekateDisplayForm } from '@onshape/www-inertia';
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';
import ExternalUtil from '../../../../ExternalUtil';

export default class StartupProgramProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public override realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    if (!formDefinition.value) {
      return;
    }
    super.realtimeBranchModifications({ formDefinition });

    const formVariantFieldVal = ExternalUtil.findDisplayFieldValOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.formVariant,
    });

    // shown and required by default, hidden and not-required on reapply
    const startupHowDidYouHearAboutUsField = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.startupHowDidYouHear,
    });
    startupHowDidYouHearAboutUsField.isRequired = true;

    const startupTellUsAboutBusinessField = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.startupTellUsAboutYourBusiness,
    });
    startupTellUsAboutBusinessField.isRequired = true;

    // hidden by default, shown on reapply
    const howHasOnshapeHelped = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.howHasOnshapeHelped,
    });
    howHasOnshapeHelped.componentName = 'hidden-field';
    howHasOnshapeHelped.isRequired = false;
    const startupCanWeShare = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.startupCanWeShare,
    });
    startupCanWeShare.componentName = 'hidden-field';
    startupCanWeShare.isRequired = false;

    const startupBusinessSummaryUpdate = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.startupBusinessSummaryUpdate,
    });
    startupBusinessSummaryUpdate.componentName = 'hidden-field';

    // Using watch as field is not filled out on initial load
    watch(formVariantFieldVal, (newVal) => {
      if (newVal === 'StartupReapply') {
        // hide default fields
        startupHowDidYouHearAboutUsField.componentName = 'hidden-field';
        startupHowDidYouHearAboutUsField.isRequired = false;

        startupTellUsAboutBusinessField.componentName = 'hidden-field';
        startupTellUsAboutBusinessField.isRequired = false;

        // show reapply fields
        howHasOnshapeHelped.componentName = howHasOnshapeHelped.initialComponentName;
        howHasOnshapeHelped.isRequired = true;
        startupCanWeShare.componentName = startupCanWeShare.initialComponentName;
        startupCanWeShare.isRequired = true;
        startupBusinessSummaryUpdate.componentName =
          startupBusinessSummaryUpdate.initialComponentName;
        startupBusinessSummaryUpdate.isRequired = true;
      }
    });

    // inject refCode from URL if present
    const { getInitParam } = useWwwLocation();
    const refCode = getInitParam('refCode');
    if (refCode) {
      ExternalUtil.findDisplayFieldOrThrow({
        formDefinition,
        fieldName: FieldHtmlNameUtil.referralCode,
      }).val = refCode;
    }
  }
}
